import React, { ComponentProps } from 'react';

export const Form = (p: React.InputHTMLAttributes<HTMLFormElement>) => (
	<form {...p} />
);

export type FormProps = ComponentProps<typeof Form>;
